import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { initials } from "@/lib/format";
import { cn } from "@/lib/utils";

export const RoleLabel = ({ role }) => (role === "admin" ? "Amministratore" : "Collaboratore");

export const UserMenu = ({ compact = false }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="user-menu-trigger"
        className={cn("flex w-full items-center gap-3 rounded-xl p-2 text-left hover:bg-accent transition-colors", compact && "justify-center")}
      >
        <Avatar className="h-9 w-9 border border-brand-gold/40">
          <AvatarImage src={user?.picture || undefined} alt={user?.name} />
          <AvatarFallback className="bg-brand-soft text-brand-dark dark:bg-brand-line dark:text-brand-light text-xs font-semibold">
            {initials(user?.name)}
          </AvatarFallback>
        </Avatar>
        {!compact && (
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-medium" data-testid="user-menu-name">{user?.name}</span>
            <span className="block truncate text-xs text-muted-foreground" data-testid="user-menu-role"><RoleLabel role={user?.role} /></span>
          </span>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="top" className="w-56 rounded-xl">
        <DropdownMenuLabel className="font-normal">
          <span className="block text-sm font-medium">{user?.name}</span>
          <span className="block text-xs text-muted-foreground truncate">{user?.email}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onLogout} data-testid="logout-button" className="cursor-pointer">
          <LogOut className="mr-2 h-4 w-4" /> Esci
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
